// extracted by mini-css-extract-plugin
export default {"Modal":"📚19-10-2lWZo9"};